<template>
  <div class="mx-3 mb-3 mt-3 flex-none sm:m-5 md:w-80">
    <div class="col-span-4 mr-1 rounded-xl border border-gray-200 bg-white shadow">
      <div class="p-4">
        <div class="mb-2 flex items-center justify-between gap-3">
          <div class="mb-3 text-sm font-bold tracking-wide text-gray-700">模試一覧</div>
          <div
            v-if="showTicketCount"
            class="inline-flex max-w-full rounded-full bg-green-100 px-3 py-2 text-sm font-semibold text-green-800">
            チケット残り枚数 x
            {{ remainingPurchaseTicket }}
          </div>
        </div>
        <template v-if="isExistedWithinPeriodExam">
          <div
            v-for="(examination, i) in examinations"
            :key="i"
            :class="{
              'bg-indigo-500': selectedExaminationIndex === i,
              'text-white': selectedExaminationIndex === i,
            }">
            <template
              v-if="examination.is_published && isWithinPeriodExam(examination)
              ">
              <button
                class="w-full"
                @click="selectExamination(i)">
                <div
                  class="flex min-h-[44px] cursor-pointer items-center border px-3 py-2 text-left text-base text-grey-darkest hover:bg-indigo-500 hover:text-white">
                  <div class="text-sm font-medium leading-5">
                    {{ examination.title }}
                  </div>
                </div>
              </button>
            </template>
          </div>
        </template>
        <template v-else>
          <div
            class="relative mt-2 w-full rounded-lg border border-gray-200 bg-gray-50 px-4 py-4 text-center text-gray-600">
            <span class="block text-sm font-bold sm:inline">購入期間中の模試はありません</span>
          </div>
        </template>

        <div class="my-5 border-b border-gray-200"></div>

        <div class="mt-4 border-2 rounded-md">
          <button
            class="flex min-h-[44px] w-full select-none items-center justify-between p-3 text-left font-semibold text-gray-800"
            :aria-expanded="isOpen"
            @click="toggleAccordion()">
            <span>過去の模試一覧</span>
            <svg
              class="h-3 w-3 transform transition-all duration-200"
              :class="{
                'rotate-180': isOpen,
                'rotate-0': !isOpen,
              }"
              fill="none"
              stroke="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 10">
              <path
                d="M15 1.2l-7 7-7-7"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </button>
          <div v-show="isOpen">
            <div
              v-for="{ examination, index } in pastExaminations"
              :key="examination.id || index"
              :class="{
                'bg-indigo-500': selectedExaminationIndex === index,
                'text-white': selectedExaminationIndex === index,
              }">
              <button
                class="w-full"
                @click="selectExamination(index)">
                <div
                  class="flex min-h-[44px] cursor-pointer items-center border px-3 py-2 text-left text-base text-grey-darkest hover:bg-indigo-500 hover:text-white">
                  <div class="text-sm font-medium leading-5">
                    {{ examination.title }}
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import moment from 'moment'

const props = defineProps({
  examinations: {
    type: Array,
    required: true,
  },
  selectedExaminationIndex: {
    type: Number,
    required: true,
  },
  remainingPurchaseTicket: {
    type: Number,
    required: false,
    default: 0,
  },
  showTicketCount: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['select-examination'])

const isOpen = ref(false)

const toggleAccordion = () => {
  isOpen.value = !isOpen.value
}

const selectExamination = (index) => {
  emit('select-examination', index)
}

const isWithinPeriodExam = (examination) => {
  const now = moment()
  return now.isBefore(examination.reception_end)
}

const isExistedWithinPeriodExam = computed(() => props.examinations
  .some((examination) => isWithinPeriodExam(examination) && examination.is_published))

const isOutOfTermExam = (examination) => {
  const now = moment()
  return now.isAfter(examination.reception_end)
}

const pastExaminations = computed(() => props.examinations
  .map((examination, index) => ({ examination, index }))
  .filter(({ examination }) => examination.is_published && isOutOfTermExam(examination))
  .sort((a, b) => {
    const aDate = moment(a.examination.start_date || a.examination.reception_end || 0)
    const bDate = moment(b.examination.start_date || b.examination.reception_end || 0)

    return bDate.diff(aDate)
  }))
</script>
